"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function UploadFolderIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M21.627,23.151H2.374c-1.17,0-2.121-.91-2.121-2.029V9.926c0-1.119,.951-2.029,2.121-2.029h1.505v1.699h-1.505c-.229,0-.422,.151-.422,.33v11.196c0,.179,.193,.33,.422,.33H21.627c.229,0,.422-.151,.422-.33V9.926c0-.179-.193-.33-.422-.33h-1.506v-1.699h1.506c1.17,0,2.121,.91,2.121,2.029v11.196c0,1.119-.951,2.029-2.121,2.029Z" }),
        react_1.default.createElement("rect", { x: "5.531", y: ".849", width: "12.939", height: "1.466" }),
        react_1.default.createElement("rect", { x: "9.201", y: "15.251", width: "5.6", height: "1.334" }),
        react_1.default.createElement("path", { d: "M12.283,4.618c-.163-.144-.408-.144-.571,0l-5.586,5.163c-.148,.142-.153,.377-.011,.524,.077,.08,.186,.122,.296,.113h2.786v3.819s5.603,0,5.603,0v-3.819h2.785c.204,.016,.383-.136,.399-.34,.009-.111-.033-.22-.113-.297l-5.589-5.163Z" })));
}
exports.default = UploadFolderIcon;
